export const DIGITAL_HEALTH_URL = 'https://www.digitalhealth.gov.au';
export const DIGITAL_HEALTH_MHR_ACCESS_URL =
  'https://www.digitalhealth.gov.au/initiatives-and-programs/my-health-record/getting-started/how-to-access-my-health-record';
export const DIGITAL_HEALTH_MHR_RESTRICT_ACCESS_URL =
  'https://www.digitalhealth.gov.au/initiatives-and-programs/my-health-record/manage-your-record/privacy-and-access/restrict-access-to-your-record';
